import React, { useEffect, useCallback, useState, useRef } from 'react';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { Tabs, TabList, TabPanels, Tab } from '@chakra-ui/react';
import { FiTrash2, FiMinus, FiPlus } from 'react-icons/fi';
import { search } from 'ss-search';
import { v4 as uuid } from 'uuid';
// import { uuid } from 'uuidv4';

import getValidationErrors from '../../../utils/getValidationErrors';
import { useProdutoHook } from '../../../hooks/produtohook';
import { useToast } from '../../../hooks/toast';
import { formatPrice } from '../../../utils/format';
import Input from '../../Inputs/Input';
import InputTextArea from '../../Inputs/inputTextArea';

import {
  Container,
  Content,
  Header,
  TabsView,
  TabDetalhes,
  FormView,
  TabComplementos,
  Buttons,
  Complementos,
  Complemento,
} from './styles';

interface ModalDATA {
  id?: string;
  onClose: any;
  isVisible: boolean;
  grupo: GrupoDATA;
  produtos: ProdutoDATA[];
}
interface ProdutoDATA {
  id: string;
  categoria: string;
  cod_barras: string;
  complementos: string;
  descricao: string;
  nome: string;
  promocao: string;
  qtd: number;
  status: string;
  total: number;
  valor: number;
  url_imagem: string;
}
interface GrupoDATA {
  id: string;
  nome: string;
  obrigatorio: string;
  min_itens: number;
  max_itens: number;
  complementos: ComplementoDATA[];
}
interface ComplementoDATA {
  cod: string;
  nome: string;
  descricao: string;
  valor: number;
  qtd_gratis: number;
  qtd_maxima: number;
}
interface FormDetalhesPARAMS {
  nome: string;
  obrigatorio: string;
  min: number;
  max: number;
}
interface FormCompPARAMS {
  cod: string;
  nome: string;
  descricao: string;
  valor: string;
  qtd_gratis: number;
  qtd_maxima: number;
}

const ModalGrupoComplemento: React.FC<ModalDATA> = ({
  // id = 'ModalGrupoComplemento',
  onClose = () => {},
  isVisible,
  grupo,
  produtos,
}) => {
  const formDetailsRef = useRef<FormHandles>(null);
  const formCompRef = useRef<FormHandles>(null);
  const { produto, addHookGrupo, setHookGrupo } = useProdutoHook();
  const { addToast } = useToast();

  const [visible, setVisible] = useState(isVisible);
  const [tabIndex, setTabIndex] = useState(0);

  const [radioObrig, setRadioObrig] = useState(grupo?.obrigatorio || 'N');
  const [descriptionLength, setDescriptionLength] = useState(0);
  const [auxGrupo, setAuxGrupo] = useState<GrupoDATA>({} as GrupoDATA);
  const [minMax, setMinMax] = useState({
    min_itens: grupo?.min_itens || 0,
    max_itens: grupo?.max_itens || 1,
  });

  const [comps, setComps] = useState<ComplementoDATA[]>([]);
  const [compsExcluded, setCompsExcluded] = useState<ComplementoDATA[]>([]);

  const [minMaxComp, setMinMaxComp] = useState({
    qtd_gratis: 0,
    qtd_maxima: 1,
  });
  const [pesquisa, setPesquisa] = useState<any[]>([]);
  const [visibles, setVisibles] = useState('');

  useEffect(() => {
    setAuxGrupo(grupo);

    const aux = grupo.complementos;

    setComps(aux);
  }, [produto, grupo]);

  const handleDescriptionLength = useCallback(() => {
    const leng = formCompRef.current?.getFieldValue('descricao').length;
    setDescriptionLength(leng);
  }, []);

  const handleMoeda = useCallback(() => {
    let moedastr = formCompRef.current?.getFieldValue('valor');
    moedastr = moedastr.replace(/\D/g, '');

    if (moedastr) {
      const moeda = parseInt(moedastr.replace(/[\D]+/g, ''));

      let tmp = `${moeda}`;
      tmp = tmp.replace(/([0-9]{2})$/g, ',$1');
      if (tmp.length > 6)
        tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2');

      formCompRef.current?.setFieldValue('valor', `R$ ${tmp}`);
    } else {
      moedastr = moedastr.replace(/\D/g, '');
      formCompRef.current?.setFieldValue('valor', `R$ ${moedastr}`);
    }
  }, []);

  const handleAddQtd = useCallback(
    (qtd: number, operator: string, minmax: string) => {
      if (operator === '+') {
        if (minmax === 'min') {
          qtd += 1;
          setMinMax({ ...minMax, min_itens: qtd });
        } else {
          qtd += 1;
          setMinMax({ ...minMax, max_itens: qtd });
        }
      } else if (minmax === 'min') {
        if (minMax.min_itens === 0) {
          return;
        }
        qtd -= 1;
        setMinMax({ ...minMax, min_itens: qtd });
      } else {
        if (minMax.max_itens === 1) {
          return;
        }
        qtd -= 1;
        setMinMax({ ...minMax, max_itens: qtd });
      }
    },
    [minMax, setMinMax],
  );

  const handleAddQtdComp = useCallback(
    (qtd: number, operator: string, minmax: string) => {
      if (operator === '+') {
        if (minmax === 'min') {
          qtd += 1;
          setMinMaxComp({ ...minMaxComp, qtd_gratis: qtd });
        } else {
          qtd += 1;
          setMinMaxComp({ ...minMaxComp, qtd_maxima: qtd });
        }
      } else if (minmax === 'min') {
        if (minMaxComp.qtd_gratis === 0) {
          return;
        }
        qtd -= 1;
        setMinMaxComp({ ...minMaxComp, qtd_gratis: qtd });
      } else {
        if (minMaxComp.qtd_maxima === 1) {
          return;
        }
        qtd -= 1;
        setMinMaxComp({ ...minMaxComp, qtd_maxima: qtd });
      }
    },
    [minMaxComp, setMinMaxComp],
  );

  const handleSubmitDetalhes = useCallback(
    async (data: FormDetalhesPARAMS) => {
      try {
        data.obrigatorio = radioObrig;

        formDetailsRef.current?.setErrors({});

        const schema = Yup.object().shape({
          nome: Yup.string().required('Nome do grupo obrigatório'),
          obrigatorio: Yup.string().required(
            'Opcional ou obrigatori é obrigatório',
          ),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const { nome, obrigatorio } = data;

        const uid = auxGrupo.id ? auxGrupo.id : uuid();

        setAuxGrupo({
          ...auxGrupo,
          id: uid,
          nome,
          obrigatorio,
          min_itens: minMax.min_itens,
          max_itens: minMax.max_itens,
          complementos: auxGrupo.complementos ? auxGrupo.complementos : [],
        });

        setTabIndex(1);
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formDetailsRef.current?.setErrors(errors);
        }
      }
    },
    // [radioObrig, grupo?.complementos, minMax],
    [radioObrig, auxGrupo, minMax],
  );

  const handleSubmitComplemento = useCallback(
    async (data: FormCompPARAMS) => {
      try {
        formCompRef.current?.setErrors({});

        const schema = Yup.object().shape({
          cod: Yup.string().required('Nome do grupo obrigatório'),
          nome: Yup.string().required('Nome do complemento obrigatório'),
          descricao: Yup.string(),
          valor: Yup.string().required('Preço do complemento obrigatório'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        if (auxGrupo.complementos) {
          const findIndex = auxGrupo.complementos.find(
            item => item.cod === data.cod,
          );
          if (findIndex) {
            addToast({
              type: 'error',
              title: 'Código já existe!',
              description: 'Já existe um complemento com este mesmo código.',
            });
            return;
          }
        }

        const auxComps = auxGrupo.complementos || [];
        data.qtd_gratis = minMaxComp.qtd_gratis;
        data.qtd_maxima = minMaxComp.qtd_maxima;

        const { cod, nome, descricao, valor } = data;

        let aux = valor.replace('R$ ', '');
        aux = aux.replace('.', '');
        aux = aux.replace(',', '.');

        const auxComp = {
          cod,
          nome,
          descricao,
          valor: parseFloat(aux),
          qtd_gratis: minMaxComp.qtd_gratis,
          qtd_maxima: minMaxComp.qtd_maxima,
        };

        auxComps.push(auxComp);

        setAuxGrupo({ ...auxGrupo, complementos: auxComps });

        formCompRef.current?.reset();
        setMinMaxComp({ qtd_gratis: 0, qtd_maxima: 1 });
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formCompRef.current?.setErrors(errors);
        }
      }
    },
    [auxGrupo, addToast, minMaxComp],
  );

  const handleRemoveComplemento = useCallback(
    (comp: ComplementoDATA) => {
      const indexComp = auxGrupo.complementos.findIndex(
        item => item.cod === comp.cod,
      );

      const auxComps = auxGrupo.complementos;

      if (grupo.id) {
        setCompsExcluded(oldArray => [...oldArray, comp]);
      }

      auxComps.splice(indexComp, 1);

      setAuxGrupo({ ...auxGrupo, complementos: auxComps });
    },
    [grupo, auxGrupo],
  );

  const handleSave = useCallback(() => {
    if (grupo.id) {
      setAuxGrupo({ ...auxGrupo, complementos: comps });
      setHookGrupo(auxGrupo);
    } else {
      addHookGrupo(auxGrupo);
    }

    onClose();
  }, [addHookGrupo, setHookGrupo, grupo, auxGrupo, onClose, comps]);

  const handleCancel = useCallback(() => {
    setVisible(false);

    if (grupo.id) {
      const auxComps = auxGrupo.complementos;

      compsExcluded.map(item => {
        auxComps.push(item);
        return item;
      });

      setCompsExcluded([]);
    }

    setTimeout(() => {
      onClose();
    }, 200);
  }, [onClose, grupo, auxGrupo, compsExcluded]);

  const handlePesquisa = useCallback(
    (text: string) => {
      const texto =
        text === 'cod'
          ? formCompRef.current?.getFieldValue('cod')
          : formCompRef.current?.getFieldValue('nome');

      if (texto === '' || texto === ' ') {
        setPesquisa([]);
        setVisibles('');
        return;
      }

      setVisibles(text);
      const searchKeys = ['nome', 'cod_barras'];
      const results = search(produtos, searchKeys, texto);

      setPesquisa(results);
      setVisibles(results.length > 0 ? text : '');
    },
    [produtos],
  );
  const handleSelectProduto = useCallback(
    (item: ProdutoDATA) => {
      formCompRef.current?.setFieldValue('cod', item.cod_barras);
      formCompRef.current?.setFieldValue('nome', item.nome);
      formCompRef.current?.setFieldValue('descricao', item.descricao);
      formCompRef.current?.setFieldValue('preco', item.valor);
      handleMoeda();
    },
    [handleMoeda],
  );

  return (
    <Container id="ModalGrupoComplemento">
      <Content className={`${visible ? 'active' : ''}`}>
        <Header>
          <h1>Novo grupo de complementos</h1>
        </Header>

        <TabsView>
          <Tabs className="tabs" index={tabIndex}>
            <TabList className="tab-list">
              <Tab className="tab" onClick={() => setTabIndex(0)}>
                Detalhes
              </Tab>
              <Tab
                className="tab"
                onClick={() => setTabIndex(auxGrupo.id ? 1 : 0)}
              >
                Complemento
              </Tab>
            </TabList>

            <TabPanels className="tab-panels">
              <TabDetalhes className="tab-panel">
                <FormView
                  ref={formDetailsRef}
                  // initialData={grupo}
                  initialData={auxGrupo}
                  onSubmit={handleSubmitDetalhes}
                  comp={auxGrupo?.complementos?.length > 0 ? 'S' : 'N'}
                >
                  <div className="input">
                    <p>
                      Nome do grupo de Complementos{' '}
                      <span className="span-p">(obrigatório)</span>
                    </p>
                    <Input
                      name="nome"
                      type="text"
                      placeholder="Nome do Grupo"
                      containerStyle={{ padding: '5px 10px' }}
                    />
                  </div>

                  <div className="input input-space">
                    <p>Obrigatoriedade</p>
                    <span>
                      Indique se este grupo é necessário para pedir o item.
                    </span>

                    <div className="radio-group">
                      <div className="radio">
                        <div className="radio-label">
                          <input
                            type="radio"
                            value="N"
                            checked={radioObrig === 'N'}
                            onChange={() => {
                              setRadioObrig('N');
                              setMinMax({ ...minMax, min_itens: 0 });
                            }}
                          />
                          <label>Opcional</label>
                        </div>
                      </div>
                      <div className="radio">
                        <div className="radio-label">
                          <input
                            type="radio"
                            value="S"
                            checked={radioObrig === 'S'}
                            onChange={() => {
                              setRadioObrig('S');
                              minMax.min_itens === 0 &&
                                setMinMax({ ...minMax, min_itens: 1 });
                            }}
                          />
                          <label>Obrigatório</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="content-qtds">
                    <div className="input">
                      <p>Quantidade</p>
                      <span>
                        Indique quantos complementos pode ser selecionados.
                      </span>
                    </div>

                    <div className="qtds">
                      <div className="input-qtd">
                        <span>Mínimo</span>

                        <div className="qtd">
                          <button
                            type="button"
                            disabled={
                              (radioObrig === 'S' && minMax.min_itens === 1) ||
                              radioObrig === 'N'
                            }
                            onClick={() =>
                              handleAddQtd(minMax.min_itens, '-', 'min')
                            }
                          >
                            <FiMinus />
                          </button>
                          <span>{minMax.min_itens}</span>
                          <button
                            type="button"
                            disabled={
                              minMax.min_itens === minMax.max_itens ||
                              radioObrig === 'N'
                            }
                            onClick={() =>
                              handleAddQtd(minMax.min_itens, '+', 'min')
                            }
                          >
                            <FiPlus />
                          </button>
                        </div>
                      </div>

                      <div className="input-qtd">
                        <span>Máximo</span>
                        <div className="qtd">
                          <button
                            type="button"
                            disabled={minMax.max_itens === 1 ? true : false}
                            onClick={() =>
                              handleAddQtd(minMax.max_itens, '-', 'max')
                            }
                          >
                            <FiMinus />
                          </button>
                          <span>{minMax.max_itens}</span>
                          <button
                            type="button"
                            onClick={() =>
                              handleAddQtd(minMax.max_itens, '+', 'max')
                            }
                          >
                            <FiPlus />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Buttons>
                    <button
                      type="button"
                      className="button-cancel"
                      onClick={handleCancel}
                    >
                      Cancelar
                    </button>
                    <button type="submit" className="button-save">
                      Próximo
                    </button>
                  </Buttons>
                </FormView>
              </TabDetalhes>

              <TabComplementos
                className="tab-panel"
                comp={auxGrupo?.complementos?.length > 0 ? 'S' : 'N'}
              >
                <div className="panel">
                  <FormView
                    ref={formCompRef}
                    onSubmit={handleSubmitComplemento}
                    comp={auxGrupo?.complementos?.length > 0 ? 'S' : 'N'}
                  >
                    <div className="input">
                      <p>
                        Código <span className="span-p">(obrigatório)</span>
                      </p>
                      <Input
                        name="cod"
                        type="text"
                        placeholder="Código do complemento"
                        containerStyle={{ padding: '5px 10px' }}
                        onChange={() => handlePesquisa('cod')}
                        onBlur={() => {
                          setTimeout(() => {
                            setVisibles('');
                          }, 200);
                        }}
                      />

                      {visibles === 'cod' && (
                        <div className="pesquisa-produto">
                          {pesquisa.map((item, indice) => (
                            <div
                              className="pesquisa-item"
                              key={indice}
                              onClick={() => handleSelectProduto(item)}
                            >
                              <span>{item.nome}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    <div className="input">
                      <p>
                        Nome <span className="span-p">(obrigatório)</span>
                      </p>
                      <Input
                        name="nome"
                        type="text"
                        placeholder="Nome do complemento"
                        containerStyle={{ padding: '5px 10px' }}
                        onChange={() => handlePesquisa('nome')}
                        onBlur={() => {
                          setTimeout(() => {
                            setVisibles('');
                          }, 200);
                        }}
                      />

                      {visibles === 'nome' && (
                        <div className="pesquisa-produto nome">
                          {pesquisa.map((item, indice) => (
                            <div
                              className="pesquisa-item"
                              key={indice}
                              onClick={() => handleSelectProduto(item)}
                            >
                              <span>{item.nome}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    <div className="input">
                      <p>Descrição</p>
                      <InputTextArea
                        name="descricao"
                        placeholder="Descrição"
                        rows={3}
                        cols={5}
                        max={5000}
                        onChange={handleDescriptionLength}
                        containerStyle={{ padding: '5px 10px' }}
                      />

                      <span className="span-caracter">
                        {descriptionLength ? descriptionLength : 0}/5000
                        caracteres
                      </span>
                    </div>

                    <div className="input">
                      <p>
                        Preço <span>(obrigatório)</span>
                      </p>
                      <Input
                        name="valor"
                        type="text"
                        placeholder="Preço"
                        onChange={handleMoeda}
                        containerStyle={{ padding: '5px 10px' }}
                      />
                    </div>

                    <div className="content-qtds complemento">
                      <div className="input">
                        <p>Quantidade</p>
                      </div>

                      <div className="qtds">
                        <div className="input-qtd">
                          <span>Grátis</span>
                          <div className="qtd">
                            <button
                              type="button"
                              disabled={
                                minMaxComp.qtd_gratis === 0 ? true : false
                              }
                              onClick={() =>
                                handleAddQtdComp(
                                  minMaxComp.qtd_gratis,
                                  '-',
                                  'min',
                                )
                              }
                            >
                              <FiMinus />
                            </button>
                            <span>{minMaxComp.qtd_gratis}</span>
                            <button
                              type="button"
                              onClick={() =>
                                handleAddQtdComp(
                                  minMaxComp.qtd_gratis,
                                  '+',
                                  'min',
                                )
                              }
                            >
                              <FiPlus />
                            </button>
                          </div>
                        </div>

                        <div className="input-qtd">
                          <span>Máximo</span>
                          <div className="qtd">
                            <button
                              type="button"
                              disabled={
                                minMaxComp.qtd_maxima === 1 ? true : false
                              }
                              onClick={() =>
                                handleAddQtdComp(
                                  minMaxComp.qtd_maxima,
                                  '-',
                                  'max',
                                )
                              }
                            >
                              <FiMinus />
                            </button>
                            <span>{minMaxComp.qtd_maxima}</span>
                            <button
                              type="button"
                              onClick={() =>
                                handleAddQtdComp(
                                  minMaxComp.qtd_maxima,
                                  '+',
                                  'max',
                                )
                              }
                            >
                              <FiPlus />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <button className="button-add">Adicionar</button>
                  </FormView>

                  <Complementos>
                    {auxGrupo.complementos &&
                      auxGrupo.complementos?.map((comp, indice) => (
                        <Complemento key={indice}>
                          <div className="header">
                            <h1>{comp.nome}</h1>
                            <h1>{formatPrice(comp.valor)}</h1>
                          </div>

                          <div className="description">
                            <h2>{comp.descricao}</h2>

                            <h2>
                              min: {comp.qtd_gratis} - max: {comp.qtd_maxima}
                            </h2>
                          </div>

                          <label
                            className="remove-complemento"
                            onClick={() => handleRemoveComplemento(comp)}
                          >
                            <FiTrash2 />
                          </label>
                        </Complemento>
                      ))}
                  </Complementos>
                </div>

                <Buttons>
                  <button
                    type="button"
                    className="button-cancel"
                    onClick={handleCancel}
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className="button-save"
                    onClick={handleSave}
                    disabled={auxGrupo.complementos?.length > 0 ? false : true}
                  >
                    Salvar
                  </button>
                </Buttons>
              </TabComplementos>
            </TabPanels>
          </Tabs>
        </TabsView>
      </Content>
    </Container>
  );
};

export default ModalGrupoComplemento;
